import script from "./BikelaneSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./BikelaneSlider.vue?vue&type=script&setup=true&lang=js"

import "./BikelaneSlider.vue?vue&type=style&index=0&id=60fa8182&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60fa8182"]])

export default __exports__